import { Store } from "../../@types/contexts/authContext/store.types";

const initialState: Store = {
	user: null,
	isLoggedIn: false
};

export default initialState;
